import React, { useRef, useEffect } from "react";
var ArticlePopover = function ArticlePopover(_ref) {
  var hotData = _ref.hotData,
    c = _ref.c,
    image = _ref.image,
    ga = _ref.ga,
    g4 = _ref.g4;
  var contentRef = useRef(null);
  var list = [{
    title: "新車上市",
    href: "".concat(c, "/news?t=18")
  }, {
    title: "國內車訊",
    href: "".concat(c, "/news?t=1")
  }, {
    title: "排行報告",
    href: "".concat(c, "/news?t=6")
  }, {
    title: "國外車訊",
    href: "".concat(c, "/news?t=3")
  }, {
    title: "優惠快訊",
    href: "".concat(c, "/news?t=2")
  }, {
    title: "車展報告",
    href: "".concat(c, "/news?t=8")
  }, {
    title: "售後資訊",
    href: "".concat(c, "/article/after-sale")
  }, {
    title: "汽車趣聞",
    href: "".concat(c, "/news?t=17")
  }, {
    title: "編輯精選",
    href: "".concat(c, "/news?t=22")
  }, {
    title: "品牌專訪",
    href: "".concat(c, "/feature/4135")
  }];
  var Item = function Item(_ref2) {
    var item = _ref2.item,
      i = _ref2.i;
    var itemRef = useRef(null);
    useEffect(function () {
      var observe = new IntersectionObserver(function (entrie) {
        if (entrie[0].isIntersecting) {
          g4("article_exposured", {
            page: "首頁",
            spm: "",
            channel: "文章",
            module: "頂部導航下拉框",
            element: "文章",
            element_id: item.id,
            next_spm: "2.46.85.105"
          });
        }
      }, {
        threshold: 0
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      itemRef.current && observe.observe(itemRef.current);
    }, []);
    return /*#__PURE__*/React.createElement("a", {
      ref: itemRef,
      href: "".concat(item.link).concat(item.link.includes("?") ? "&" : "?", "spm=2.46.85.105"),
      target: '_blank',
      onClick: function onClick() {
        g4("article_clicked", {
          page: "首頁",
          spm: "",
          channel: "文章",
          element: "文章",
          element_id: item.id,
          module: "頂部導航下拉框",
          object_id: "",
          next_spm: "2.46.85.105"
        });
      },
      rel: 'noreferrer'
    }, /*#__PURE__*/React.createElement("span", {
      className: i <= 2 ? "hot-".concat(i, "-item hot-rank") : "hot-rank"
    }), /*#__PURE__*/React.createElement("img", {
      className: 'article-hot-list-image',
      src: item.thumb
    }), /*#__PURE__*/React.createElement("p", {
      className: 'article-hot-list-title'
    }, item.title));
  };
  useEffect(function () {
    var observe = new IntersectionObserver(function (entrie) {
      if (entrie[0].isIntersecting) {
        g4("article_column_exposured", {
          page: "首頁",
          spm: "",
          channel: "文章",
          module: "頂部導航下拉框",
          element: "新聞分類",
          element_id: list.map(function (item) {
            return item.title;
          }).join(","),
          next_spm: ""
        });
        g4("article_column_exposured", {
          page: "首頁",
          spm: "",
          channel: "文章",
          module: "頂部導航下拉框",
          element: "熱門欄目",
          element_id: "搶先試駕、超級測試、車用品超級測試、PK比較",
          next_spm: ""
        });
      }
    }, {
      threshold: 0.2
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    contentRef.current && observe.observe(contentRef.current);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover article',
    ref: contentRef
  }, /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-left',
    style: {
      marginRight: 0
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title'
  }, "\u65B0\u805E\u5206\u985E"), /*#__PURE__*/React.createElement("div", {
    className: 'article-new-type'
  }, list.map(function (item, index) {
    return /*#__PURE__*/React.createElement("a", {
      key: index,
      href: item.href,
      target: '_blank',
      onClick: function onClick() {
        g4("article_column_clicked", {
          page: "首頁",
          spm: "",
          channel: "文章",
          module: "頂部導航下拉框",
          element: "新聞分類",
          element_id: item.title,
          next_spm: ""
        });
      },
      rel: 'noreferrer'
    }, item.title);
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-left'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title',
    style: {
      marginLeft: "10px"
    }
  }, "\u71B1\u9580\u6B04\u76EE"), /*#__PURE__*/React.createElement("ul", {
    className: 'article-popover-list'
  }, /*#__PURE__*/React.createElement("li", {
    className: 'article-popover-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(c, "/trialrun/?type=21"),
    onClick: function onClick() {
      ga(["导航", "文章", "抢先试驾"]);
      g4("article_column_clicked", {
        page: "首頁",
        spm: "",
        channel: "文章",
        module: "頂部導航下拉框",
        element: "熱門欄目",
        element_id: "搶先試駕",
        next_spm: ""
      });
    },
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'article-popover-list-image',
    src: "".concat(image, "/home/nav/icon_9.png")
  }), /*#__PURE__*/React.createElement("p", {
    className: 'article-popover-list-title'
  }, "\u6436\u5148\u8A66\u99D5"))), /*#__PURE__*/React.createElement("li", {
    className: 'article-popover-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(c, "/trialrun/?type=23&page=1"),
    onClick: function onClick() {
      ga(["导航", "文章", "超级测试"]);
      g4("article_column_clicked", {
        page: "首頁",
        spm: "",
        channel: "文章",
        module: "頂部導航下拉框",
        element: "熱門欄目",
        element_id: "超級測試",
        next_spm: ""
      });
    },
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'article-popover-list-image',
    src: "".concat(image, "/home/nav/icon_7.png")
  }), /*#__PURE__*/React.createElement("p", {
    className: 'article-popover-list-title'
  }, "\u8D85\u7D1A\u6E2C\u8A66"))), /*#__PURE__*/React.createElement("li", {
    className: 'article-popover-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(c, "/feature/4134"),
    onClick: function onClick() {
      ga(["导航", "文章", "买车大补贴"]);
      g4("article_column_clicked", {
        page: "首頁",
        spm: "",
        channel: "文章",
        module: "頂部導航下拉框",
        element: "熱門欄目",
        element_id: "車用品超級測試",
        next_spm: ""
      });
    },
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'article-popover-list-image',
    src: "https://photo.8891.com.tw/2023/08/30/1693359165935371.png"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'article-popover-list-title'
  }, "\u8ECA\u7528\u54C1\u8D85\u7D1A\u6E2C\u8A66"))), /*#__PURE__*/React.createElement("li", {
    className: 'article-popover-list-item'
  }, /*#__PURE__*/React.createElement("a", {
    href: "".concat(c, "/Guide"),
    onClick: function onClick() {
      ga(["导航", "文章", "超详细图解"]);
      g4("article_column_clicked", {
        page: "首頁",
        spm: "",
        channel: "文章",
        module: "頂部導航下拉框",
        element: "熱門欄目",
        element_id: "PK比較",
        next_spm: ""
      });
    },
    target: '_blank',
    rel: 'noreferrer'
  }, /*#__PURE__*/React.createElement("img", {
    className: 'article-popover-list-image',
    src: "https://photo.8891.com.tw/2023/08/29/1693308076028158.png"
  }), /*#__PURE__*/React.createElement("p", {
    className: 'article-popover-list-title'
  }, "PK\u6BD4\u8F03"))))), /*#__PURE__*/React.createElement("div", {
    className: 'tc-top-nav-popover-left'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'hot-article'
  }, /*#__PURE__*/React.createElement("h3", {
    className: 'tc-top-nav-popover-title',
    style: {
      marginBottom: 0,
      marginLeft: 0
    }
  }, "\u6700\u71B1\u6587\u7AE0"), /*#__PURE__*/React.createElement("a", {
    href: "".concat(c, "/Articles"),
    className: 'more'
  }, "\u67E5\u770B\u5168\u90E8")), /*#__PURE__*/React.createElement("ul", {
    className: 'article-hot-list'
  }, hotData.map(function (item, i) {
    return /*#__PURE__*/React.createElement("li", {
      className: 'article-hot-list-item',
      key: i
    }, /*#__PURE__*/React.createElement(Item, {
      item: item,
      i: i
    }));
  }))));
};
export default ArticlePopover;